import type { FetchOptions, FetchRequest, MappedResponseType, ResponseType } from 'ofetch'
import type { ModuleOptions } from '../../types/module'
import { defu } from 'defu'
import { createError, useRuntimeConfig } from 'nuxt/app'
import { $fetch } from 'ofetch'
import { useLocale } from '../composables/locale'
import { useUserSession } from '../composables/userSession'
import { CONFIG_KEY } from '../config'

type ExtendedFetchOptions<R extends ResponseType = 'json'> = FetchOptions<R> & {
  extended?: {
    throwFatalError?: boolean
  }
}

export function $backendFetch<T = any, R extends ResponseType = 'json'>(request: FetchRequest, options?: ExtendedFetchOptions<R>): Promise<MappedResponseType<R, T>> {
  const { accessToken } = useUserSession()
  const { locale } = useLocale()
  return $fetch(
    request,
    defu(
      options,
      {
        baseURL: (useRuntimeConfig().public[CONFIG_KEY] as ModuleOptions).backend.apiUrl,
        async onRequest({ options }) {
          options.headers.set('Accept', 'application/json')
          options.headers.set('X-Locale-Id', String(locale.value?.id))
          const token = accessToken.value?.token
          if (token) {
            options.headers.set('Authorization', `Bearer ${token}`)
          }
        },
        onRequestError({ error }) {
          throw createError({ status: 500, statusText: error.toString(), fatal: true })
        },
        onResponseError({ response }) {
          const throwError = options?.extended?.throwFatalError ?? true
          if (throwError && response.status !== 422) {
            throw createError({
              status: response.status,
              statusText: response.statusText,
              fatal: true,
            })
          }
        },
      },
    ),
  )
}
